/* External Packages */
import 'bootstrap';
import 'popper.js';
import 'slick-carousel';

/* Internal Files */
import general from './general.js';
import navigation from './navigation.js';
import blocks from '../blocks/blocks.js';
/* loader.js is bundled separately via Webpack. Do not import it here! */
/* lighthouse.js is bundled separately via Webpack. Do not import it here! */

document.addEventListener('DOMContentLoaded', function () {
    general();
    navigation();
    blocks();
});
